import { GetBulkOrderResData } from 'requests/RequestPayment';
import { convertPriceDisplay } from 'common/PriceConverter';
import { Hr } from 'components/atoms/Hr';
import { BulkPaymentItem } from 'components/molecules/bulk-payment-item/BulkPaymentItem';
import { BulkPaymentRemarks } from 'components/molecules/bulk-payment-remarks/BulkPaymentRemarks';
import classes from './bulk-payment.module.scss';

export const useBulkPeriodicPaymentOverview = (order: GetBulkOrderResData) => {
	type Props = {
		cardError?: string;
		error?: string;
		isConfirmPage?: true;
	};
	const BulkPeriodicPaymentOverview = (props: Props) => {
		const { cardError = '', error = '', isConfirmPage = false } = props;
		if (!order) {
			return null;
		}
		return (
			<>
				{order.logo && (
					<>
						<div className={classes.paymentLogo}>
							<img src={order.logo} alt="" />
						</div>
						<Hr />
					</>
				)}
				<div className={`section-head ${order.logo ? classes.marginTop30 : ''}`}>
					<span>{isConfirmPage ? `ご注文内容の確認` : `お支払い方法の選択`}</span>
				</div>
				{(!!cardError || !!error) && (
					<div className="error-box">
						<div className="error-box-in">
							{!!cardError && <p>{cardError}</p>}
							{!!error && <p>{error}</p>}
						</div>
					</div>
				)}
				<div className="section-txt-box">
					<div className="txt">
						{isConfirmPage ? (
							<div>以下の内容をご確認いただき「注文する」ボタンを押してください。</div>
						) : (
							<>
								<div>お支払い方法を選択の上「次へ」ボタンを押してください。</div>
								<div>すべての取引は安全で、暗号化されています。</div>
							</>
						)}
					</div>
				</div>
				<div className={classes.bulkPaymentOverview}>
					<BulkPaymentItem items={order.items} />
					<div className={classes.payments}>
						{order.periodic_info.payments.map((payment, i) => {
							const isFirst = i === 0;
							return (
								<>
									{!isFirst && <Hr />}
									<div className={classes.payment}>
										<div className={`${classes.paymentTitle} ${isFirst ? '' : classes.paymentTitleMargin}`}>
											{isFirst && (
												<div className={classes.iconWrap}>
													<img className={classes.icon} src={`${process.env.PUBLIC_URL}/images/cart.svg`} alt="" />
												</div>
											)}
											<div className={classes.paymentTitleText}>{payment.title}</div>
										</div>
										<div className={classes.paymentTotal}>{convertPriceDisplay(payment.total)}</div>
									</div>
									{isFirst && !!order.periodic_info.free_text && (
										<div className={classes.freeText}>{order.periodic_info.free_text}</div>
									)}
									{payment.detail.length > 0 && <div className={classes.detailLabel}>＜内訳＞</div>}
									{payment.detail.map((d) => {
										return (
											<div className={classes.paymentDetail}>
												<div className={classes.paymentDetailKey}>{d.key}</div>
												<div className={classes.paymentDetailValue}>
													{d.is_price ? convertPriceDisplay(d.value) : d.value}
												</div>
											</div>
										);
									})}
									{!!payment.sub_text && <div className={classes.subText}>{payment.sub_text}</div>}
								</>
							);
						})}
					</div>
				</div>
				{!isConfirmPage && <BulkPaymentRemarks remarks={order.remarks} />}
			</>
		);
	};

	return {
		BulkPeriodicPaymentOverview,
	};
};
